/**
 * openOnMount — señal one-shot "abrir el chat de Paulina al montar".
 *
 * Problema que resuelve (FIX A): al aceptar la invitación desde la variante `control`,
 * el PaulinaProvider AÚN NO está montado (PaulinaGate sólo monta con offered=true). El
 * `gate.accept()` cambia la variante a treatment → offered pasa a true → el provider se
 * MONTA recién después. Un `setOpen(true)` en el tick del accept no tendría a quién
 * abrir (el hook todavía no existe).
 *
 * Solución: una bandera one-shot respaldada en sessionStorage. La invitación la SETEA
 * justo antes de `gate.accept()` (markOpenOnMount) y el hook del chat la CONSUME al
 * montar (consumeOpenOnMount). Al vivir en sessionStorage SOBREVIVE al remonte del
 * provider; al consumirse se limpia, de modo que el chat se abre UNA sola vez y no en
 * cada montaje posterior.
 */

// Clave namespaceada (prefijo pau_ como el resto de la telemetría/flags de Paulina) para
// no chocar con otras banderas de sessionStorage.
const OPEN_ON_MOUNT_KEY = 'pau_open_on_mount';

/** Marca que el próximo montaje del chat debe abrirlo (one-shot). */
export const markOpenOnMount = (): void => {
  try {
    sessionStorage.setItem(OPEN_ON_MOUNT_KEY, '1');
  } catch {
    /* sin storage: el chat simplemente no se auto-abrirá (degradación aceptable). */
  }
};

/**
 * Devuelve true UNA sola vez si la señal estaba puesta, y la limpia (one-shot).
 * Llamadas posteriores devuelven false hasta que se vuelva a marcar.
 *
 * @returns {boolean} true si el chat debe auto-abrirse en este montaje; false en otro caso.
 */
export const consumeOpenOnMount = (): boolean => {
  try {
    const armed = sessionStorage.getItem(OPEN_ON_MOUNT_KEY) === '1';
    if (armed) sessionStorage.removeItem(OPEN_ON_MOUNT_KEY);
    return armed;
  } catch {
    return false;
  }
};
